// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_contour_offset_frame/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_contour_offset_frame: ModuleSchema = {
  "id": "core_contour_offset_frame",
  "uniqueId": "B3D_0L7PU",
  "createdAt": "2026-10-11T05:00:00Z",
  "updatedAt": "2026-10-28T14:57:47.768Z",
  "label": "Contour Offset Frame",
  "description": "Standalone core geometry module for contour-following 2D offset border frame (CG_FRM01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_FRM01",
    "contour-frame",
    "offset-border"
  ],
  "sliders": [
    {
      "key": "demoShape",
      "label": "Demo Shape (0:Star, 1:Cross, 2:Heart)",
      "min": 0,
      "max": 2,
      "default": 0,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "offset",
      "label": "Border Margin (mm)",
      "min": 0.1,
      "max": 2,
      "default": 0.4,
      "step": 0.05,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "depth",
      "label": "Frame Depth (mm)",
      "min": 0.2,
      "max": 3,
      "default": 0.5,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "inner",
      "label": "Inner Shape Color",
      "default": "#3B82F6",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "frame",
      "label": "Offset Frame Color",
      "default": "#EAB308",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "inner_shape",
      "name": "Inner Target Shape",
      "parts": [
        {
          "id": "inner_part",
          "name": "Inner Geometry",
          "groupId": 0,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    },
    {
      "id": "border_frame",
      "name": "Contour Border Frame",
      "parts": [
        {
          "id": "border_part",
          "name": "Hugging Border Frame",
          "groupId": 1,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    },
    {
      "id": "0",
      "label": "Download STL - Inner Shape"
    },
    {
      "id": "1",
      "label": "Download STL - Border Frame"
    }
  ]
};
